import { DotLegalOverflowMenuItem } from "@dotlegal/dotlegal-ui-components";
import { getPlanDialogOverflowMenuItem } from "../plan/planOverflowMenuItem/PlanOverflowMenuItem.tsx";

/**
 * The overflow entry for an AI action on a contract. Usable, it explains on hover what the action will do before
 * the user starts it, which from a document row is the only explanation they get. Blocked by the plan, it keeps the
 * lock and opens the plan dialog. Disabled for any other reason (a file too large for AI), it only says why, because
 * buying the plan would not help.
 */
export function getAiOverflowMenuItem(
    onClick: () => void,
    labelKey: string,
    descriptionKey: string,
    blockedTooltip: string | undefined,
    translateString: (key: string) => string,
    disabledTooltip?: string
): DotLegalOverflowMenuItem {
    // The plan comes first: a customer without it is told what to buy, whatever else is wrong.
    if (blockedTooltip !== undefined) {
        return getPlanDialogOverflowMenuItem(onClick, false, translateString(labelKey), blockedTooltip);
    }

    if (disabledTooltip !== undefined) {
        return { menuItem: translateString(labelKey), tooltip: disabledTooltip, tooltipPosition: "left", disabled: true };
    }

    // To the left: below, the text covers the menu items underneath it.
    return {
        menuItem: translateString(labelKey),
        onClick,
        tooltip: translateString(descriptionKey),
        tooltipPosition: "left",
    };
}
